// packages
const { h, Component } = require("preact");
import * as moment from 'moment';

// components
import ByCategoryRow from './ByCategory/ByCategoryRow.js';

// internal
import data from '../../../data/data.json';
import mapData from '../../../data/county_category_map.json';

const asOfDate = moment('2022-11-08', 'YYYY-MM-DD');

class CategoryComparsion extends Component {
  constructor() {
    super();

    this.state = {}
  }

  render() {
    // const sortedData = data['daily_by_category'].sort((a, b) => b.reg_voters - a.reg_voters)
    // console.log(sortedData)
   
    return (
      <div>
        <ByCategoryRow
          data={data['categories']}
          date={asOfDate}
          mapData={mapData}
        />
      </div>
    )
  }
}

export default CategoryComparsion;